import React, { memo } from "react";
import CommonCaseCard from "../../components/CommonCaseCard/CommonCaseCard";
import "./CaseCard.css"

const CaseCard = memo(({ selectCards }) => {
   
  return (
   <div>
      {selectCards &&
        selectCards.map((item, index) => {
          // Get and format Submitted Date for the top badge
          const submittedField = item.find((i) => i.label === "Submitted Date");
          const formattedSubmittedDate = submittedField?.value
            ? (() => {
                const date = new Date(submittedField.value);
                return `${String(date.getDate()).padStart(2, "0")}/${String(
                  date.getMonth() + 1
                ).padStart(2, "0")}/${date.getFullYear()}`;
              })()
            : "-";

          // Remove "Submitted Date" from card details
          const updatedItem = item.filter((field) => field.label !== "Submitted Date");
          
          return (
            <div key={`submittedCaseCard-${index}`} className="case-card-wrapper">
              <CommonCaseCard
                key={`submittedCaseCard-${index}`}
                cardDetail={updatedItem}
                btn={false}
               cardType={"Submitted"}
               caseType={"Submitted"}
               formattedSubmittedDate={formattedSubmittedDate}
              />
            </div>
          );
        })}
    </div>
  );
});

CaseCard.propTypes = {};

export default CaseCard;
